let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("in8iE")).then(() => parcelRequire('68hi8'));